<script lang="ts">
  import { t } from "$lib/services/i18n";
  import { register } from "$lib/store/auth-context";
  import { Views, screenSize } from "$lib/store/detect-view";
  import { makeDebounce } from "$lib/utils";

  import { slide } from "svelte/transition";
  // import { onMount } from "svelte";

  export let step: number;
  export let email: string;

  function onSubmit(ev: Event) {
    ev.stopImmediatePropagation();
    ev.preventDefault();

    const form = new FormData(ev.currentTarget as HTMLFormElement);
    const payload = Object.fromEntries(form);

    // console.log("submission in progress", payload);
    register(payload)
      .then(() => {
        step = 3;
      })
      .catch();
  }

  const DEBOUNCE_TIME = 100; //ms
  let emailConfirm: string;
  let disabled = true;
  let hasEmail = false;
  const checkEmailFn = makeDebounce(() => {
    disabled = email.toLowerCase() !== emailConfirm.toLowerCase();
  }, DEBOUNCE_TIME);
  function checkMail() {
    hasEmail = `${email}`.trim().length > 0 && `${emailConfirm}`.trim().length > 0;
    if (!hasEmail) {
      disabled = true;
      return;
    }
    checkEmailFn();
  }
</script>

<div class="actions">
  <h1 class="pf-700"><slot />Create an account</h1>
  <hr />

  <p class="pf-500">No account found, please sign up.</p>

  <form method="POST" on:submit={onSubmit}>
    <div>
      <div class:grid={$screenSize === Views.DESKTOP}>
        <label for="forename">
          <span>{$t("First Name")}</span>
          <input name="forename" placeholder={$t("First Name")} type="text" required />
        </label>

        <label for="surname">
          <span>{$t("Last Name")}</span>
          <input name="surname" placeholder={$t("Last Name")} type="text" required />
        </label>
      </div>

      <div class:grid={$screenSize === Views.DESKTOP}>
        <label for="email">
          <span>{$t("Enter email")}</span>
          <input
            name="email"
            type="mail"
            placeholder={$t("Email")}
            bind:value={email}
            on:input={checkMail}
            on:copy={ev => ev.preventDefault()}
            required
          />
        </label>
        <label for="confirm-email">
          <span>{$t("Confirm-email")}</span>
          <input
            name="confirm-email"
            placeholder={$t("Confirm Email")}
            type="mail"
            bind:value={emailConfirm}
            on:input={checkMail}
            required
          />
        </label>
      </div>
      {#if hasEmail && disabled}
        <p transition:slide class="pf-400 show">The email and confirm email fields do not match</p>
      {/if}
    </div>
    <input name="email" type="hidden" required bind:value={email} />

    <button type="submit" class="register" {disabled}>Sign up</button>
    <button type="button" class="register" on:click={() => (step = 1)}>Back</button>
  </form>
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .actions {
    position: relative;

    h1 {
      font-size: 1.25em;
      margin: 1em 0;
    }

    hr {
      width: 100%;
      margin-top: 1em;
      border-top: 1px solid var(--hr-color);
    }

    p {
      font-size: 0.875em;
      margin: calc(1em / 0.875 * 2.25) 0;
      @include desktop {
        max-width: calc(1em / 0.875 * 21.75) 0;
      }
    }

    form {
      label {
        margin: 0 auto;
        width: 100%;
        @include desktop {
          width: 98%;
        }

        > span {
          text-align: left;
          display: block;
          @include desktop {
            display: inline;
          }
        }
      }

      input {
        padding: 0.63em 1.43em 0.63em 1.75em;
        background: #fff;
        border-radius: 0.3125em;
        border: 1px solid #404469;
        height: 3.125em;
        // max-width: 35.5rem;
      }

      .register {
        height: 3.75em;
        margin: 1.25em 0 0.625em;
        padding: 0em 3.75em;
        height: 3.09em;
        border-radius: 0.3125em;
        max-width: 35.5em;
        margin: 20px auto 10px;
        @include desktop {
          padding: 0em 3.75em;
          height: 3.125em;
        }
      }

      p {
        &.show {
          color: #ff0000;
          text-align: center;
          display: block;
          line-height: 3.125em;
          margin-left: 0.75em;
        }
      }
    }
  }
</style>
